import React, { useState } from 'react';
import { licenses } from '../data/licenses';
import '../css/ThirdPartyNotices.css';

const ThirdPartyNotices = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState(null);

  const toggleModal = () => {
    setIsOpen(!isOpen);
    setSelectedLicense(null);
  };

  const toggleLicenseDetails = (license) => {
    setSelectedLicense(selectedLicense === license ? null : license);
  };

  return (
    <div className="third-party-notices">
      <button 
        className="btn btn--notices"
        onClick={toggleModal}
        aria-label="Third Party Notices anzeigen"
      >
        Third Party Notices
      </button>

      {isOpen && (
        <div className="notices-modal-overlay" onClick={toggleModal}>
          <div className="notices-modal" onClick={(e) => e.stopPropagation()}>
            <div className="notices-header">
              <h2>Third Party Notices</h2>
              <button 
                className="notices-close"
                onClick={toggleModal}
                aria-label="Schließen"
              >
                ✕
              </button>
            </div>

            <div className="notices-content">
              <div className="notices-intro">
                <p>Dieses Projekt verwendet die folgenden Open-Source-Pakete und deren Lizenzen.</p>
              </div>

              <div className="licenses-grid">
                {Object.entries(licenses).map(([license, data]) => (
                  <div 
                    key={license} 
                    className="license-card"
                    onClick={() => toggleLicenseDetails(license)}
                  >
                    <div className="license-header">
                      <h3>{license}</h3>
                      <span className="license-count">{data.count} Pakete</span>
                    </div>
                    
                    {selectedLicense === license && (
                      <div className="license-details">
                        <ul className="package-list">
                          {data.packages.map((pkg, idx) => (
                            <li key={idx}>{pkg}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="notices-footer">
                <p>
                  Weitere Informationen finden Sie in der{' '}
                  <a href="/THIRD_PARTY_NOTICES.md" download="THIRD_PARTY_NOTICES.md">
                    THIRD_PARTY_NOTICES.md
                  </a>
                  {' '}Datei.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ThirdPartyNotices;
